module.exports = __webpack_public_path__ + "static/appstore-f1d65072752b60ccc0b614a696f5028e.svg";